'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function PEFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-f8p2k5z7d", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-ow94qto3o", fill: "#fff" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M4.936.154l.91 1.287c-.408.857-.456 1.81-.143 2.858.47 1.572-.025 2.784-2.113 2.918-.293.056-.491.12-.593.194v.124l-.008-.041a.157.157 0 00-.031-.048.129.129 0 00-.035.048l-.008.041v-.124c-.101-.074-.299-.138-.592-.194C.235 7.083-.26 5.871.21 4.3c.313-1.048.265-2-.144-2.858L.977.154c.363.268.678.402.945.402.268 0 .626-.134 1.076-.402l-.083.092V.154l.04.024.043-.024v.094L2.915.154c.45.268.808.402 1.075.402.267 0 .582-.134.946-.402z"
      }
    )), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-f8p2k5z7d)" }, /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M8 0h17v24H8z" }), /* @__PURE__ */ React.createElement("path", { fill: "#f50101", d: "M24 0h8v24h-8zM0 0h8v24H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#a2bb6a",
        fillRule: "nonzero",
        d: "M15.741 8.745l.034.362c-.999.101-1.538-.387-1.538-1.4 0-1.004.528-1.538 1.52-1.544l.002.363c-.804.005-1.174.38-1.174 1.182 0 .793.359 1.118 1.156 1.037zm.443 0l-.034.362c.998.101 1.538-.387 1.538-1.4 0-1.004-.528-1.538-1.52-1.544l-.002.363c.804.005 1.174.38 1.174 1.182 0 .793-.359 1.118-1.156 1.037z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#e31d1c",
        d: "M15.936 16.575c.126.246 0 .218 0 .548 0 .33.08.805-.491.805-.572 0-.453-.263-1.248-.263h-1.29v-.542c.567.03 1.029.047 1.385.05h.279c.295-.003.485-.02.569-.05.287-.103-.533-.335-.533-.548 0-.213 1.203-.246 1.329 0zm.157 0c.126-.246 1.328-.213 1.328 0s-.819.445-.532.548c.084.03.273.047.569.05h.28c.355-.003.817-.02 1.385-.05v.542h-1.29c-.796 0-.678.263-1.249.263-.571 0-.491-.476-.491-.805 0-.33-.127-.302 0-.548z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#00a854",
        d: "M16.407 17.175s1.519-.151 1.863-.699.915-1.483 1.116-1.71c.202-.226.215.324.215.324s.332.47.332-.131c0-.602-.236-.182-.547-1.087s-.484-1.795-.397-1.93.294.135.294 0v-.397l.318.398.332-.126s.273.585.441.766c.169.181.267-.242.218-.64-.05-.398-.66-.398-.66-.398s-.78-.42-.78-.597c0-.117.113-.158.338-.123l-.104-.546c.186.221.324.276.413.166.134-.166-.198-.457-.198-.457h.529v-.255l.244.137-.244-.558c-.478.072-.76.072-.847 0-.13-.108-.54-.529-.54-.529v-.2h-.237l.236-.4v-.638l.859.171v-.471c.805.393 1.136.747.99 1.064s-.217.65-.217 1.003v.42c.024-.085.097-.128.218-.128.181 0 .387.094.387.384s.37-.118.37-.118v1.21s.087.13.276 0c.19-.132.107-.03-.463.737-.57.766-.365.768-.183.58.183-.187.923-.721.646-.454-.276.267-.295.826 0 .64s.238-.318.238 0-.519 1.4-.701 1.57c-.183.169-.353.273-.57.443-.218.17-.462.372-.462.494 0 .081.154.038.462-.131l-.218.776h.423c-.224.688-.557 1.032-.998 1.032h-1.293c-.089 0-.333.094-.734.283l-.44.125c.468.044.78.137.938.277.236.21 0 .357 0 .357s-.649-.064-1.133-.21c-.484-.147-.73.13-.73-.147v-.277zm-.721-.32c-1.843-.365-2.814-.899-2.915-1.604-.151-1.057-.15-2.183-.15-2.183l-.256.688c-.008-.624.163-1.159.513-1.604.526-.668-.657.443-.657.443.4-.63.682-.975.848-1.035.25-.09-1.002.592-1.002.592.24-.528.452-.867.637-1.016.28-.225-.637.424-.637.424.139-.523.29-.848.455-.973.248-.187-.81.973-.81.973.373-1.197.663-1.851.873-1.963.314-.167-.518.33-.518.33.34-.513.662-.896.966-1.15.457-.382-.825.162-.668.162.31-.348.552-.572.73-.67.266-.148-1.028.508-1.028.508.62-.683 1.022-1.075 1.207-1.176.279-.15-1.366.814-1.366.814a9.64 9.64 0 00.137-.766c.042-.32-.762.875-.652 1.948s-.438-.82-.438-.82c-.146.274-.041.77.315 1.488l-.58-.811c.054.49.142.868.265 1.133.124.265-.051.045-.526-.66-.09.44-.09.66 0 .66.542.724.823 1.191.843 1.402.03.317-.913-1.13-1.039-1.13-.126 0-.196.465 0 .465s.568.665.568.665c-.322-.232-.518-.355-.587-.369-.103-.02.082.207.215.37-.252.205-.368.385-.349.54.029.234 1.03.283 1.465 1.39-.6-.317-.973-.476-1.116-.476-.215 0 .346.497.526.662.18.164-.278-.165-.402 0s.687.866.84.866H10.8c.132.186.289.28.47.28.274 0 1.251.438 1.251.58s-.824-.182-.977-.182 1.076 1.16 1.73 1.205c.652.044 1.065.22 1.346.22h.48c-.887.45-1.33.677-1.33.677h.443c.576 0 1.018.16 1.245-.171.227-.332.227-.726.227-.726z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        stroke: "#e8aa00",
        d: "M18.17 8.164l1.393 1.967c-.482.815-.555 1.733-.25 2.752.302 1.013.23 1.885-.227 2.515-.402.556-1.124.961-2.303 1.044l-.155 4.845-.542-2.694-.549 2.734.008-5.077c-1.334.11-2.055-.296-2.458-.852-.456-.63-.528-1.502-.226-2.515.25-.837.246-1.606-.031-2.306l-.205-.467 1.378-1.946c.434.35.769.62 1.05.62.174 0 .395-.095.661-.241l-.16-.162h1.083l-.005.25.014.006c.162.079.289.125.397.14l.078.007c.281 0 .616-.27 1.05-.62z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#67baff",
        d: "M.174 0h2.783v3.818H.174z",
        mask: "url(#mantine-ow94qto3o)",
        transform: "translate(13.13 8.727)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M2.957 0h2.782v3.818H2.957z",
        mask: "url(#mantine-ow94qto3o)",
        transform: "translate(13.13 8.727)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#c51918",
        d: "M-.174 4.182h6.957v4.363H-.174z",
        mask: "url(#mantine-ow94qto3o)",
        transform: "translate(13.13 8.727)"
      }
    ), /* @__PURE__ */ React.createElement("g", { fill: "#c9a951", fillRule: "nonzero" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M4.304 3.548h-.347V.933h.347z",
        mask: "url(#mantine-ow94qto3o)",
        transform: "translate(13.13 8.727)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M4.163 2.358l-.17.304-.6-.335.17-.304zm0-.727l-.17.304-.6-.336.17-.303z",
        mask: "url(#mantine-ow94qto3o)",
        transform: "translate(13.13 8.727)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M4.86 2.358l-.17.304-.6-.335.169-.304zm0-.727l-.17.304-.6-.336.169-.303z",
        mask: "url(#mantine-ow94qto3o)",
        transform: "matrix(-1 0 0 1 22.079 8.727)"
      }
    )), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fbcd17",
        d: "M4.599 4.978c.161-.185.242-.23.242-.139 0 .139 0 .371-.121.371s-.685-.11-.9-.37c-.214-.26-.669-.714-1.253-.607-.585.106-1.278.864-1.45.864-.17 0-.545.585-.272 1.04.273.457.737.315.737.448 0 .132.116.147.55.147s.594.154.97.154-.124-.006.482-.154c.605-.147 1.064-.594.711-.594h-.711c-.245 0-.79.176-.79 0s.121-.554.456-.365c.334.189 1.262.332 1.59 0s.445-.533.387-.934c-.038-.267-.207-.362-.507-.285z",
        mask: "url(#mantine-ow94qto3o)",
        transform: "translate(13.13 8.727)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#d18219",
        d: "M2.246.843c-.21.183-.075.853-.418.853-.344 0-.827-.502-.949-.17s0 .22 0 .501S.587 3.093.733 3.226s.295.481.27.318C.977 3.38.866 3.14.913 2.88c-.045-.27.245-.529.245-.529s-.031.28-.054.384c-.064.14-.083.257-.057.35.065.263.112.403.139.421.017-.621.036-.983.056-1.086.03-.154.243.173.314.136.016.426.012.664-.013.714-.05.1-.065.167-.047.2.047.116.09.157.129.123l.032-.174c-.023-.068-.017-.18.02-.336.038-.343.065-.477.081-.403-.007.162-.002.285.017.368.029.208.046.323.052.345.14.2.212.257.216.173-.134-.16-.187-.3-.158-.422-.077-.345-.062-.556.045-.633.285-.132.435-.31.452-.535.042-.257.066-.444.073-.562-.062-.034-.029-.082.1-.143.208-.08.247-.174.118-.285",
        mask: "url(#mantine-ow94qto3o)",
        transform: "translate(13.13 8.727)"
      }
    )))
  );
}

export { PEFlag };
//# sourceMappingURL=PE.mjs.map
